import React, { useContext, useEffect, useState } from "react";
import { Box } from "../components/styled/Elements";
import AdminHeader from "../components/admin/AdminHeader/AdminHeader";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import AdminSidebar from "../components/admin/AdminSidebar/AdminSidebar";
import UsersApi from "../services/api/usersApi";
import { useDispatch } from "react-redux";
import {
  setBranchesDeps,
  setHqBranchesList,
  setUsersList,
} from "../store/slices/helperSlice";
import HQBranchesApi from "../services/api/hqBranchesApi";
import { useTranslation } from "react-i18next";
import { useUser } from "../context/userContext";
import { AuthContext } from "../context/authContext";
import TourGuide from "../components/common/tourGuide/TourGuide";
import DashboardApi from "../services/api/dashboardApi";

const AdminLayout = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const { user, fetchUserInfo } = useUser();
  const { isAuthenticated } = useContext(AuthContext);
  const [tourCompleted, setTourCompleted] = useState(true);
  const [sidebarStatus, setSidebarStatus] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user && !user?.onboarding_shown) {
      setSidebarStatus(true);
    }
  }, [user]);

  const pollForUpdates = (interval = 60000) => {
    let pollingInterval;

    const startPolling = () => {
      if (navigator.onLine) {
        pollingInterval = setInterval(async () => {
          fetchUserInfo();
        }, interval);
      }
    };

    const stopPolling = () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };

    // Listen for online/offline events
    const handleOnline = () => {
      startPolling();
    };

    const handleOffline = () => {
      stopPolling();
    };

    // Attach event listeners
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Start polling
    startPolling();

    // Cleanup function
    return () => {
      stopPolling();
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  };

  useEffect(() => {
    let pollingInterval;
    const userType = Number(user?.user_type_id);

    const startPolling = () => {
      if (navigator.onLine) {
        pollingInterval = setInterval(async () => {
          fetchUserInfo();
        }, 60000);
      }
    };

    const stopPolling = () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };

    // Listen for online/offline events
    const handleOnline = () => {
      startPolling();
    };

    const handleOffline = () => {
      stopPolling();
    };

    if (userType === 4 || userType === 3) {
      // Attach event listeners
      window.addEventListener("online", handleOnline);
      window.addEventListener("offline", handleOffline);

      // Start polling
      startPolling();
    }

    // Cleanup function
    return () => {
      stopPolling();
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const getUsersListWithoutPg = async () => {
    try {
      const { data, code } = await UsersApi.getUsersListWithoutPg();

      if (code === 200) {
        if (data && data.length > 0) {
          const updatedUsers = data?.map((user) => ({
            ...user,
            role: user?.position,
            subLabel: `${
              language === "en"
                ? user?.user_detail?.department_selective?.name_en
                : user?.user_detail?.department_selective?.name_ar
            }  (${
              language === "en"
                ? user?.user_detail?.office_location_selective?.name_en
                : user?.user_detail?.office_location_selective?.name_ar
            })`,
          }));
          dispatch(setUsersList(updatedUsers));
        }
      }
    } catch (error) {}
  };
  const getHqBranchesWithoutPg = async () => {
    try {
      const { data, code } = await HQBranchesApi.getHqBranchesListWithoutPg();
      if (code === 200) {
        dispatch(setHqBranchesList(data));
      }
    } catch (error) {}
  };

  const getBranchesDepartments = async () => {
    try {
      const { data, code } = await HQBranchesApi.getBranchesDepartments();

      if (code === 200) {
        const branchesDepsArr = data?.map((item) => ({
          id: item?.id,
          name: item?.name,
          subLabel: item?.location?.name,
          location_id: item?.location_id,
        }));

        dispatch(setBranchesDeps(branchesDepsArr));
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (
      (isAuthenticated && !user?.current_organization?.plan_detail?.expired) ||
      (isAuthenticated &&
        user?.current_organization?.plan_detail?.expired &&
        user?.current_organization?.plan_detail?.is_grace_period_active)
    ) {
      getUsersListWithoutPg();
      getHqBranchesWithoutPg();
      getBranchesDepartments();
    }
  }, [language]);

  return (
    <LayoutWrapper className="d-flex center-main">
      <TourGuide />
      <Box>
        <AdminSidebar
          sidebarStatus={sidebarStatus}
          setSidebarStatus={setSidebarStatus}
        />
      </Box>
      <Box className="flex-1 w-100">
        <AdminHeader
          sidebarStatus={sidebarStatus}
          setSidebarStatus={setSidebarStatus}
        />
        <Box className={"flex-1 custom-scroll pb-4 content-main"}>
          <Outlet />
        </Box>
      </Box>
    </LayoutWrapper>
  );
};

export default AdminLayout;

const LayoutWrapper = styled.div`
  background-color: var(--bgSecondary);
`;
